import { createContext } from "react"
import type { InstagramAccount } from "../components/settings/AccountsTab"

export type OrganizationWithAccounts = {
  id: number
  name: string
  role: "member" | "owner" | null
  active_members_count: number
  instagram_accounts_count: number
  created_at: string
  accounts: InstagramAccount[]
}

export const PrefetchedOrgsContext = createContext<OrganizationWithAccounts[] | null>(null)
